import { themeObject } from '../../lib';

type SdzColors = {
    [key: string]: string;
};

const sdzColors: SdzColors = {
    dev: themeObject.palette.primary[100],
    stage: themeObject.palette.secondary[50],
    uat: themeObject.palette.tertiary.purple[50],
    prod: themeObject.palette.tertiary.red[100],
};

export { sdzColors };
